$.mediaQuery = function (size) {
    const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
    const breakpoints = [0, 576, 768, 992, 1200, 1400];

    const sizeIndex = sizes.indexOf(size);
    return window.matchMedia(`(min-width: ${breakpoints[sizeIndex]}px)`)
        .matches;
};
